import { logUsage } from 'owa-analytics';
import { timestamp } from 'owa-datetime';
import type { FluidLoadOwaScenario, FluidOwaSource } from 'owa-fluid-validations';

// The user cancelled the loading the fluid component
// not success or failure.
export function fluidComponentCancelled(
    owaScenario: FluidLoadOwaScenario,
    owaSource: FluidOwaSource,
    scenarioStartTime: number
) {
    logUsage(
        'FluidComponentCancelled',
        {
            OwaScenario_1: owaScenario,
            OwaSource_4: owaSource,
            ElapsedTime_5: timestamp() - scenarioStartTime,
        },
        { isCore: true }
    );
}
